import { XSD_DATE_TIME_IRI, XSD_TIME_IRI } from 'bones/constants/iris';
import { DatatypeOperatorTypeV0 } from 'bones/utils/queryBuilder/migrate/v0/constants';
import { DataV0 } from 'bones/utils/queryBuilder/migrate/v0/types';
import {
  ConjunctionV1,
  DatatypeOperatorTypeV1,
} from 'bones/utils/queryBuilder/migrate/v1/constants';
import {
  DataV1,
  DatatypeFilterV1,
  ExpressionV1,
  FilterV1,
  TopExpressionV1,
} from 'bones/utils/queryBuilder/migrate/v1/types';

export const v1 = (data: DataV0): DataV1 => ({
  ...data,
  query: {
    conjunction: data.query.conjunction as unknown as ConjunctionV1,
    expressions: data.query.expressions.map((subExpression) => ({
      conjunction: subExpression.conjunction as unknown as ConjunctionV1,
      expressions: subExpression.expressions.map(
        (expression) =>
          ({
            filters: expression.filters.map((filter) => {
              if (
                filter.operator.isDatatype &&
                (filter.operator.range === XSD_DATE_TIME_IRI ||
                  filter.operator.range === XSD_TIME_IRI)
              ) {
                if (filter.operator.type === DatatypeOperatorTypeV0.EQUALS) {
                  return {
                    ...filter,
                    operator: {
                      ...filter.operator,
                      type: DatatypeOperatorTypeV1.ON,
                    },
                  } as DatatypeFilterV1;
                }

                if (
                  filter.operator.type === DatatypeOperatorTypeV0.DOES_NOT_EQUAL
                ) {
                  return {
                    ...filter,
                    operator: {
                      ...filter.operator,
                      type: DatatypeOperatorTypeV1.NOT_ON,
                    },
                  } as DatatypeFilterV1;
                }
              }

              return filter as unknown as FilterV1;
            }),
          } as ExpressionV1)
      ),
    })),
  } as TopExpressionV1,
});
